import { NgModule } from '@angular/core';
import { CalendarModule as AngularCalendarModule } from 'angular-calendar';
import { SharedModule } from '../../../shared';
import { ClientePipeSharedModule } from '../../pessoa/cliente/pipes';
import { AtividadeTipoPipeModule } from '../tipo/pipes';
import { AtividadeListComponent } from './atividade-list.component';

@NgModule({
    imports: [
        SharedModule,
        AngularCalendarModule,
        AtividadeTipoPipeModule,
        ClientePipeSharedModule
    ],
    declarations: [
        AtividadeListComponent
    ],
    exports: [
        AtividadeListComponent
    ]
})
export class AtividadeListModule { }
